import {
  GET_DOCUMENT_MONTHLY_STATS,
  GET_DOCUMENT_MONTHLY_STATS_FAILED,
  GET_DOCUMENT_MONTHLY_STATS_SUCCEEDED,
  GET_DOCUMENT_WEEKLY_STATS,
  GET_DOCUMENT_WEEKLY_STATS_FAILED,
  GET_DOCUMENT_WEEKLY_STATS_SUCCEEDED,
} from 'Redux/Types/StatsTypes'

const INITIAL_STATE = {
  loading: false,
  weeklyStats: [],
  monthlyStats: [],
  weeklyStatsFetched: false,
  loadingWeeklyStats: false,
  loadingMonthlyStats: false,
  monthlyStatsFetched: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_DOCUMENT_MONTHLY_STATS:
      return {
        ...state,
        loading: true,
        monthlyStatsFetched: false,
        loadingMonthlyStats: true,
      }
    case GET_DOCUMENT_MONTHLY_STATS_FAILED:
      return {
        ...state,
        loading: false,
        monthlyStatsFetched: false,
        loadingMonthlyStats: false,
      }
    case GET_DOCUMENT_MONTHLY_STATS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        monthlyStats: payload,
        monthlyStatsFetched: true,
        loadingMonthlyStats: false,
      }

    case GET_DOCUMENT_WEEKLY_STATS:
      return {
        ...state,
        loading: true,
        loadingWeeklyStats: true,
        weeklyStatsFetched: false,
      }
    case GET_DOCUMENT_WEEKLY_STATS_FAILED:
      return {
        ...state,
        loading: false,
        loadingWeeklyStats: false,
        weeklyStatsFetched: false,
      }
    case GET_DOCUMENT_WEEKLY_STATS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        weeklyStats: payload,
        weeklyStatsFetched: true,
        loadingWeeklyStats: false,
      }

    default:
      return state
  }
}
